import { CONVERSION_FACTORS, MATERIAL_CONSTANTS } from '../constants/calculator_constants';

export type BendingOpts = {
  conversionFactor?: number;      // GPa per ksi
  conversionFactorMPa?: number;   // ksi per MPa
  E0?: number;
};

export function computeBendingStress(bendRadiusMm: number, fiberCladdingDiameter: number, opts: BendingOpts = {}) {
  const {
    conversionFactor = CONVERSION_FACTORS.GPA_TO_MPA,
    conversionFactorMPa = CONVERSION_FACTORS.KSI_TO_MPA,
    E0 = MATERIAL_CONSTANTS.E0_MPA
  } = opts;

  fiberCladdingDiameter = fiberCladdingDiameter / 1000000;
  const fiberCladdingRadius = fiberCladdingDiameter / 2; // meters
  const R = bendRadiusMm / 1000; // mm -> meters
  if (!isFinite(R) || R === 0) return { kpsi: NaN, gpa: NaN };

  const E = (E0 * fiberCladdingRadius) / R; // MPa
  const E2 = (E0 * 2.3 * fiberCladdingRadius * fiberCladdingRadius) / (R * R); // MPa

  const mpa = E + E2;
  if (!isFinite(mpa)) return { kpsi: NaN, gpa: NaN };
  const rawKpsi = (mpa) / conversionFactorMPa;
  
  // Calculate GPa from the formatted kpsi value to maintain consistency
  const rawgpa = mpa / conversionFactor;

  return { rawKpsi, rawgpa };
}

export default computeBendingStress;